import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface InitializeAgentData {
  uuid: string;
}

interface InitializeAgentResponse {
  data: any;
}

export function useInitializeAgent() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      uuid,
    }: InitializeAgentData): Promise<InitializeAgentResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/initialize_agent`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ uuid }),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
